import { GetTimesheetsResponseItem } from '@sit/openapi';
import { createContext } from 'react';
import { TimesheetModalType } from './timesheet-modal-type';

export type TimesheetModalState =
  | {
      type: TimesheetModalType.NEW | TimesheetModalType.CLOSED;
    }
  | {
      type: TimesheetModalType.DUPLICATE;
      timesheetId: string;
    }
  | {
      type: TimesheetModalType.BULK_DELETE;
      timesheets: TimesheetBulkDeleteItem[];
    };

export type TimesheetBulkDeleteItem = Pick<GetTimesheetsResponseItem, 'id' | 'description'> & {
  startDate: Date | string;
  endDate: Date | string;
};

export interface TimesheetModalActions {
  openNewTimesheetModal: () => void;
  openDuplicateTimesheetModal: (timesheetId: string) => void;
  openBulkDeleteTimesheetsModal: (timesheets: TimesheetBulkDeleteItem[]) => void;
  closeModal: () => void;
}

export const TimesheetModalStateContext = createContext<TimesheetModalState>({ type: TimesheetModalType.CLOSED });

export const TimesheetModalActionsContext = createContext<TimesheetModalActions>({
  openNewTimesheetModal: () => {},
  openDuplicateTimesheetModal: () => {},
  openBulkDeleteTimesheetsModal: () => {},
  closeModal: () => {},
});
